var map = {
	"./br/PT/S1/fj.png": 46883,
	"./fj.png": 44493,
	"./in/EN/S1/fj.png": 64080,
	"./ph/EN/S1/fj.png": 12512,
	"./ph/EN/S2/fj.png": 34366,
	"./vn/VI/S1/fj.png": 45892
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30458;